/**
 * Bundle Builder — Style Variation Switcher
 * Temporary file for presenting 10 layout options to the client.
 * Reads ?v=N from URL and applies the corresponding variation.
 * Only activates when ?v= parameter is present.
 */
(function() {
  'use strict';

  var BANNER_HTML = '<div class="bundle-compare-banner__content">' +
    '<h4 class="bundle-compare-banner__heading">Which Olympus Grip should you choose?</h4>' +
    '<p class="bundle-compare-banner__desc">We\'ll help you decide. Compare Classic and SMART to see which one fits your needs.</p>' +
    '</div>' +
    '<span class="bundle-compare-banner__btn">See Comparison <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

  function upgradeToBanner(compare) {
    if (!compare) return;
    compare.classList.add('bundle-compare-banner');
    compare.innerHTML = BANNER_HTML;
  }

  var VARIATIONS = {
    1: {
      label: 'Baseline (Current)',
      desc: 'Compare: light bar above cards. Already Have: light bar below continue.',
      apply: function() { /* Default layout — no changes */ }
    },
    2: {
      label: 'Skip Above + Rich Banner Above',
      desc: 'Already Have: text link above cards. Compare: dark banner above cards (below skip).',
      apply: function() {
        var container = document.querySelector('[data-step="step-1"] .bundle-section__container');
        var compare = container.querySelector('.bundle-callout--compare');
        var skip = container.querySelector('.bundle-callout--skip');
        var grid = container.querySelector('.bundle-grip-grid');
        upgradeToBanner(compare);
        if (skip && compare && grid) {
          // Already Have first, then banner, then cards
          grid.parentNode.insertBefore(skip, grid);
          grid.parentNode.insertBefore(compare, grid);
        }
      }
    },
    3: {
      label: 'Skip Above + Rich Banner Below Cards',
      desc: 'Already Have: text link above cards. Compare: dark banner below cards.',
      apply: function() {
        var container = document.querySelector('[data-step="step-1"] .bundle-section__container');
        var compare = container.querySelector('.bundle-callout--compare');
        var skip = container.querySelector('.bundle-callout--skip');
        var grid = container.querySelector('.bundle-grip-grid');
        var continueDiv = container.querySelector('.bundle-grip-continue');
        upgradeToBanner(compare);
        if (skip && grid) {
          // Already Have above cards
          grid.parentNode.insertBefore(skip, grid);
        }
        if (compare && continueDiv) {
          // Banner below cards, above continue
          continueDiv.parentNode.insertBefore(compare, continueDiv);
        }
      }
    },
    4: {
      label: 'Swapped Light Bars',
      desc: 'Already Have: light bar above cards. Compare: light bar below cards.',
      apply: function() {
        var container = document.querySelector('[data-step="step-1"] .bundle-section__container');
        var compare = container.querySelector('.bundle-callout--compare');
        var skip = container.querySelector('.bundle-callout--skip');
        var grid = container.querySelector('.bundle-grip-grid');
        var continueDiv = container.querySelector('.bundle-grip-continue');
        if (compare && skip && grid && continueDiv) {
          grid.parentNode.insertBefore(skip, grid);
          continueDiv.parentNode.insertBefore(compare, continueDiv);
        }
      }
    },
    5: {
      label: 'Skip Pill Above + Rich Banner Above',
      desc: 'Already Have: navy pill above cards. Compare: dark banner above cards (below skip).',
      apply: function() {
        var container = document.querySelector('[data-step="step-1"] .bundle-section__container');
        var compare = container.querySelector('.bundle-callout--compare');
        var skip = container.querySelector('.bundle-callout--skip');
        var grid = container.querySelector('.bundle-grip-grid');
        upgradeToBanner(compare);
        if (skip && compare && grid) {
          // Already Have pill first, then banner, then cards
          grid.parentNode.insertBefore(skip, grid);
          grid.parentNode.insertBefore(compare, grid);
        }
      }
    },
    6: {
      label: 'Minimal & Clean',
      desc: 'Compare: text link under subtitle. Already Have: text link below continue.',
      apply: function() {
        var container = document.querySelector('[data-step="step-1"] .bundle-section__container');
        var compare = container.querySelector('.bundle-callout--compare');
        var cap = container.querySelector('.bundle-section__cap');
        if (compare && cap) {
          cap.appendChild(compare);
        }
      }
    },
    7: {
      label: 'Card-Style Callouts',
      desc: 'Compare: white card with shadow above cards. Already Have: white card with shadow below continue.',
      apply: function() { /* CSS-only, no DOM moves */ }
    },
    8: {
      label: 'Accent Left-Border',
      desc: 'Compare: blue accent border bar above cards. Already Have: green accent border bar below continue.',
      apply: function() { /* CSS-only, no DOM moves */ }
    },
    9: {
      label: 'Skip + Rich Banner Below Continue',
      desc: 'Already Have: text link below continue. Compare: dark banner below skip.',
      apply: function() {
        var container = document.querySelector('[data-step="step-1"] .bundle-section__container');
        var compare = container.querySelector('.bundle-callout--compare');
        var skip = container.querySelector('.bundle-callout--skip');
        upgradeToBanner(compare);
        if (skip && compare && container) {
          // Already Have first, then banner (both below continue)
          container.appendChild(skip);
          container.appendChild(compare);
        }
      }
    },
    10: {
      label: 'Compare Inline + Skip CTA',
      desc: 'Compare: text link under subtitle. Already Have: prominent CTA button between cards & continue.',
      apply: function() {
        var container = document.querySelector('[data-step="step-1"] .bundle-section__container');
        var compare = container.querySelector('.bundle-callout--compare');
        var skip = container.querySelector('.bundle-callout--skip');
        var cap = container.querySelector('.bundle-section__cap');
        var continueDiv = container.querySelector('.bundle-grip-continue');
        if (compare && cap) {
          cap.appendChild(compare);
        }
        if (skip && continueDiv) {
          continueDiv.parentNode.insertBefore(skip, continueDiv);
        }
      }
    },
    11: {
      label: 'Grey Bar Above + Rich Banner',
      desc: 'Already Have: grey bar above cards. Compare: dark banner above cards (below skip).',
      apply: function() {
        var container = document.querySelector('[data-step="step-1"] .bundle-section__container');
        var compare = container.querySelector('.bundle-callout--compare');
        var skip = container.querySelector('.bundle-callout--skip');
        var grid = container.querySelector('.bundle-grip-grid');
        upgradeToBanner(compare);
        if (skip && compare && grid) {
          // Grey bar first, then banner, then cards
          grid.parentNode.insertBefore(skip, grid);
          grid.parentNode.insertBefore(compare, grid);
        }
      }
    }
  };

  function getVariation() {
    var params = new URLSearchParams(window.location.search);
    var v = parseInt(params.get('v'), 10);
    return (v >= 1 && v <= 11) ? v : null;
  }

  function buildNavBar(activeV) {
    var nav = document.createElement('div');
    nav.className = 'variation-nav';

    var label = document.createElement('span');
    label.className = 'variation-nav__label';
    label.textContent = 'Variation:';
    nav.appendChild(label);

    var baseUrl = window.location.pathname;
    var params = new URLSearchParams(window.location.search);
    var themeId = params.get('preview_theme_id');

    for (var i = 1; i <= 11; i++) {
      var btn = document.createElement('a');
      btn.className = 'variation-nav__btn';
      if (i === activeV) btn.className += ' variation-nav__btn--active';
      btn.textContent = i;
      var url = baseUrl + '?v=' + i;
      if (themeId) url += '&preview_theme_id=' + themeId;
      btn.href = url;
      nav.appendChild(btn);
    }

    if (VARIATIONS[activeV]) {
      var desc = document.createElement('span');
      desc.className = 'variation-nav__desc';
      desc.textContent = VARIATIONS[activeV].desc;
      nav.appendChild(desc);
    }

    document.body.appendChild(nav);
    document.body.classList.add('has-variation-nav');
  }

  function init() {
    var v = getVariation();
    if (v === null) return;

    document.body.classList.add('bundle-v' + v);

    if (VARIATIONS[v] && VARIATIONS[v].apply) {
      VARIATIONS[v].apply();
    }

    buildNavBar(v);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
